import { Location } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { TranslationService } from 'app/core/internationalization/translation.service';
import { RouterService } from 'app/core/navigation';
import { LocalizedToasterService } from 'app/core/toaster/localized-toaster.service';
import { UserInfoSettings } from 'app/shared/models/user-info-settings.model';
import { AccountSettingsDataService } from 'app/shared/services/account-settings-data-service';
import { MergeAccountDataService } from 'app/shared/services/merge-account-data-service';

@Component({
  selector: 'kh-merge-teacher-send-email',
  styleUrls: ['./merge-teacher-send-email.component.less'],
  templateUrl: './merge-teacher-send-email.component.html',
  standalone: false
})
export class MergeTeacherSendEmailComponent implements OnInit {
  private readonly router = inject(RouterService);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly accountSettingsDataService = inject(AccountSettingsDataService);
  private readonly toaster = inject(LocalizedToasterService);
  private readonly location = inject(Location);
  private readonly mergeAccountDataService = inject(MergeAccountDataService);
  private readonly _translationService = inject(TranslationService);

  public settingsInfo$: Observable<UserInfoSettings> | undefined = undefined;

  public targetEmail = '';
  public targetDisplayName = '';

  private successTitle = '';
  private successMessage = '';

  public isEmailSent = false;

  public ngOnInit(): void {
    const queryParams = this.activatedRoute.snapshot.queryParamMap;
    this.targetEmail = queryParams.get('email') as string;
    this.targetDisplayName = queryParams.get('displayName') as string;

    this.successTitle = this._translationService.instant('MERGE_TEACHER_SEND_EMAIL.AUTHENTICATION_EMAIL_SENT');
    this.successMessage = this._translationService.instant('MERGE_TEACHER_SEND_EMAIL.WEVE_SENT_A_LINK_TO', { email: this.targetEmail });

    this.settingsInfo$ = this.accountSettingsDataService.getSettingsInfo();
  }

  public continue(): void {
    this.mergeAccountDataService.sendMergeAccountEmail(this.targetEmail)
      .pipe(
        tap(() => {
          this.toaster.success(this.successTitle, this.successMessage);
          this.isEmailSent = true;
        })
      )
      .subscribe();
  }

  public backButton(): void {
    this.location.back();
  }
}
